export default {
  labels: {
    title: 'Перетащите файлы',
    message: 'Drag "n" drop some files here',
    files: 'Файлы',
    download: 'Загрузить',
    confirm: 'Подтвердить',
  },
}
